module.exports = __webpack_public_path__ + "img/forestDetailWildlife.b98ebf26.svg";